<template>
    <!--<a-card>-->
    <div>
        <div id="cardInfo" class="cardInfo">

            <div class="header">
                <img src="../image/8e363e676e9a0cbf59d28ada0d935073.png"/>

                <a-space direction="vertical" style="color: rgb(248, 8, 8);text-align: center;">
                    <span style="font-size: 30px;">温馨提示</span>
                    <span style="font-size: 15px;">限个人车主填写，车商勿填！！</span>
                    <span style="font-size: 15px;">不能接受48小时内上门看车的也请勿填写</span>
                </a-space>

                <a-form-model
                        :model="params"
                        :label-col="labelCol"
                        :wrapper-col="wrapperCol"
                        style="margin-top: 20px;padding-left: 10px;padding-right: 10px;"
                        labelAlign="left">

                    <a-form-item label="您的名字">
                        <a-input style="width: 100%" v-model="params.name" placeholder="请输入名字"/>
                    </a-form-item>

                    <a-form-item label="您的手机号">
                        <a-input style="width: 100%" v-model="params.mobile" placeholder="请输入手机号"/>
                    </a-form-item>

                    <a-form-item label="您的位置">
                        <j-area-linkage v-model="areaCode" type="cascader"/>
                    </a-form-item>

                    <a-form-item label="您的汽车公里数">
                        <a-input style="width: 100%" v-model="params.meters" placeholder="请输入公里数"/>
                    </a-form-item>

                    <a-form-item>
                        <div style="width: 100%;text-align: left">
                            <a-checkbox v-model="isChecked"></a-checkbox>
                            <span style="margin-left: 5px">阅读并同意</span>
                            <span slot="action" style="text-align: center;color:#4e90ff">
                                <a @click="showAuthorize()">《授权书》</a>
                            </span>
                        </div>
                    </a-form-item>
                </a-form-model>


                <a-button @click="handleOk" type="primary"
                          style="width: 40%;height: 50px;margin-top: 10px;margin-bottom: 10px;">预留电话 | 预估车价
                </a-button>

                <img src="../image/6ae0bde089dcfc81b6f8dd01f46409fc.png"/>

                <img src="../image/97c4b838ea7a18f4869048ed013ebeae.png"/>
            </div>

            <div class="footerStyle">
                <div style="display: flex;flex-direction: column;justify-content: center;align-items: center;width: 100%;height: 100%;padding: 0.21333333rem 0;background: #f8f8f8">
                    <div style="padding-top: 10px;padding-bottom: 10px;text-align: center;">
                        <span style="text-align: center;font-size:0.50rem;color:#999">北京欣浩丰科技有限公司 | </span>
                        <span slot="action" style="text-align: center;font-size:0.50rem;color:#4e90ff">
                        <a @click="showProtect()">《个人信息保护声明》</a>
                        </span>
                    </div>
                </div>
            </div>
        </div>

        <user-info-protect ref="modalDialog"></user-info-protect>
        <user-authorize-modal ref="authorizeDialog"></user-authorize-modal>
        <!--</a-card>-->
    </div>
</template>

<script>
    import JAreaLinkage from '@/components/JAreaLinkage'
    import {httpAction, getAction} from '@/api/manage'
    import {Modal} from 'ant-design-vue'
    import Area from '@/utils/Area'
    import UserInfoProtect from './UserInfoProtect'
    import UserAuthorizeModal from './UserAuthorizeModal'
    import AFormItem from "ant-design-vue/es/form/FormItem";

    export default {
        components: {
            AFormItem,
            JAreaLinkage,
            UserInfoProtect,
            UserAuthorizeModal
        },
        data() {
            return {
                areaData: '',
                labelCol: {span: 14},
                wrapperCol: {span: 22},
                areaCode: '',
                isChecked: false,
                params: {
                    name: '',
                    mobile: '',
                    city: '',
                    meters: ''
                },
                url: {
                    save: 'api/savedata'
                }
            }
        },
        created() {
            this.initAreaData();
        },
        methods: {
            handleOk() {
                const that = this;
                if (!this.params.name) {
                    that.$message.warning("请填写名字");
                    return
                }
                if (!this.params.mobile) {
                    that.$message.warning("请填写手机号");
                    return
                }
                if (!that.isPhoneNumber(this.params.mobile)) {
                    that.$message.warning("请填写正确的手机号");
                    return
                }
                if (!that.areaCode) {
                    that.$message.warning("请选择城市信息");
                    return
                }
                if (!this.params.meters) {
                    that.$message.warning("请填写公里数");
                    return
                }
                if (!that.isNumeric(this.params.meters)) {
                    that.$message.warning("请填写正确的公里数");
                    return
                }
                if (!this.isChecked) {
                    that.$message.warning("请阅读并同意授权书");
                    return
                }

                //处理城市信息
                let areainfo = this.areaData.getText(that.areaCode);
                let info = areainfo.split('/')
                if (info[0].indexOf('市') != -1) {
                    this.params.city = info[0];
                } else if (info[1].indexOf('省') != -1) {
                    this.params.city = info[2];
                } else {
                    this.params.city = info[1];
                }

                httpAction(this.url.save, this.params, 'post').then((res) => {
                    if (res.success) {
                        this.showDialog();
                    }
                });
            },
            showDialog() {
                Modal.success({
                        title: '提交成功',
                        okText: '确定',
                        mask: true,
                        onOk: () => {
                            window.location.reload();
                        }
                    }
                )
            },
            initAreaData() {
                if (!this.areaData) {
                    this.areaData = new Area();
                }
            },
            isPhoneNumber(str) {
                return /^1[3456789]\d{9}$/.test(str);
            },
            isNumeric(str) {
                return /^\d+$/.test(str);
            },
            showProtect() {
                this.$refs.modalDialog.visible = true;
            },
            showAuthorize() {
                this.$refs.authorizeDialog.visible = true;
            }
        }
    }
</script>

<style lang="less" scoped>
    .cardInfo {
        width: 100%;
        height: 100%;
        min-height: 100%;
    }

    div {
        box-sizing: border-box;
        margin: 0;
        padding: 0;
        border: 0;
        -webkit-box-sizing: border-box;
        -moz-box-sizing: border-box;
        -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
        -webkit-text-size-adjust: none;
    }

    img {
        width: 100%;
    }

    .footerStyle {
        text-align: center;
        color: #999;
        font-size: .27rem;
        line-height: .37333333rem;
        font-weight: 400;
        background: #f8f8f8;
        position: fixed;
        bottom: 0;
        width: 100%;
        pointer-events: auto;
        z-index: 6;
    }
</style>
